import { DictionaryItem } from '@hglobal/fin-ui';

export const years: string[] = ['2024', '2023', '2022', '2021'];

export function getMonthlyRepYearsMock(): DictionaryItem<string>[] {
  return years.map(year => ({ id: year, name: year }));
}
